import styled from 'styled-components';

export const Container = styled.section`
    width: 100%;
    padding-top: 100px;
    max-height: 500px;
    border-bottom-right-radius: 300px;
    background-image: -webkit-linear-gradient(139deg, rgb(100, 43, 115) 0%, rgb(198, 66, 110) 100%);
    overflow: hidden;

    @media (max-width: 800px) {
        border-bottom-right-radius: 0;
    }
`

export const Content = styled.div`
    max-width: 1200px;
    width: 100%;
    height: 100%;
    margin: 0 auto;
    padding: 0 30px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    font-family: Heebo, sans-serif;
    color: #FFF;
    
    img{
        height: 400px;   
        display: flex;         
        margin: auto;

        animation-fill-mode: both;
        animation-duration: 1s;
        animation-delay: 0.1s;
        animation-iteration-count: 1;
        animation-name: enter;
    }

    div{
        display: flex;
        justify-content: center;
        flex-direction: column;
        gap: 1rem;
        
        animation-fill-mode: both;
        animation-duration: 1s;
        animation-delay: 0.1s;
        animation-iteration-count: 1;
        animation-name: enter;

        h1{
            font-size: 3.3rem;
        }
    
        p{
            font-size: 1.1rem;
            color: rgba(255, 255, 255, 0.8);
        }
    }

    
    @keyframes enter {
        0% { 
            transform: translateY(20%); 
            opacity: 0;
        }
        100% { 
            transform: translateY(0%); 
            opacity: 1;
        }
    }


    @media(max-width: 930px) {
        img{
            height: 300px;
        }

        div{
            h1{
                font-size: 2.6rem;
            }

            p{
                font-size: 0.9rem;
            }
        }
    }

    @media(max-width: 750px) {
        div{
            h1{
                font-size: 2.2rem;
            }

            p{
                font-size: 0.9rem;
            }
        }
    }


    @media (max-width: 610px) {
        grid-template-columns: 1fr;

        img{
            display: none;
        }

        div{
            padding: 2rem 0;
            text-align: center;

            h1{
                font-size: 2rem;
            }
        }
    }

    @media (max-width: 320px) {
        div{
            h1{
                font-size: 1.5rem;
            }

            p{
                font-size: 0.8rem;
            }
        }
    }
`